import type { IconSvgObject } from './types';

const FlaskConicalIcon: IconSvgObject = [
  ["path", { d: "M14.5 2V9L20.7816 19.6303C20.9246 19.8723 21 20.1483 21 20.4294C21 21.2968 20.2968 22 19.4294 22H4.57063C3.7032 22 3 21.2968 3 20.4294C3 20.1483 3.07543 19.8723 3.21843 19.6303L9.5 9V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 2H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19 16.7232C18.4694 16.8939 17.8143 17 17 17C14 17 11 14 8 14C7.65244 14 7.31998 14.0181 7 14.0512", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FlaskConicalIcon;
